(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ikh-product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__ikhPcJs) return; window.__ikhPcJs = 1;
    function toast(msg) {
      var t = document.querySelector('.ikh-toast');
      if (!t) { t = document.createElement('div'); t.className = 'ikh-toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
      t.innerHTML = msg; t.classList.add('is-on'); clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-on'); }, 3200);
    }
    document.addEventListener('submit', function (e) {
      var f = e.target.closest('[data-ikh-pc-add]'); if (!f) return;
      e.preventDefault();
      var btn = f.querySelector('.ikh-pc__btn'), id = +f.querySelector('[name=id]').value;
      if (window.ikhCart) {
        if (btn) btn.classList.add('is-loading');
        window.ikhCart.add([{ id: id, quantity: 1 }]).catch(function () { f.submit(); }).finally(function () { if (btn) btn.classList.remove('is-loading'); });
        return;
      }
      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }) })
        .then(function (r) { if (!r.ok) throw r; return fetch('/cart.js').then(function (c) { return c.json(); }); })
        .then(function (cart) {
          if (btn) { btn.classList.add('is-done'); setTimeout(function () { btn.classList.remove('is-done'); }, 1600); }
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'ikh-product-card', data: { itemCount: cart.item_count } } }));
          toast('Sepete eklendi <a href="/cart">Sepete git →</a>');
        }).catch(function () { f.submit(); });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
